module.exports = __webpack_public_path__ + "img/img_home.1db73dcf.png";